import { createLazyComponent, LazyModule } from 'owa-bundling';

const lazyModule = new LazyModule(() =>
    import(/* webpackChunkName: "MailComposeInfoBar" */ './lazyIndex')
);

export let ComposeInfoBar = createLazyComponent(lazyModule, m => m.ComposeInfoBar);
